/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.
export var ModelAttributeTypes;
(function (ModelAttributeTypes) {
    ModelAttributeTypes["binary"] = "binary";
    ModelAttributeTypes["binarySet"] = "binarySet";
    ModelAttributeTypes["bool"] = "bool";
    ModelAttributeTypes["list"] = "list";
    ModelAttributeTypes["map"] = "map";
    ModelAttributeTypes["number"] = "number";
    ModelAttributeTypes["numberSet"] = "numberSet";
    ModelAttributeTypes["string"] = "string";
    ModelAttributeTypes["stringSet"] = "stringSet";
    ModelAttributeTypes["_null"] = "_null";
})(ModelAttributeTypes = ModelAttributeTypes || (ModelAttributeTypes = {}));
export var Role;
(function (Role) {
    Role["USER"] = "USER";
    Role["COORDINATOR"] = "COORDINATOR";
    Role["RIDER"] = "RIDER";
    Role["ADMIN"] = "ADMIN";
})(Role = Role || (Role = {}));
export var CommentVisibility;
(function (CommentVisibility) {
    CommentVisibility["EVERYONE"] = "EVERYONE";
    CommentVisibility["ME"] = "ME";
})(CommentVisibility = CommentVisibility || (CommentVisibility = {}));
export var Priority;
(function (Priority) {
    Priority["HIGH"] = "HIGH";
    Priority["MEDIUM"] = "MEDIUM";
    Priority["LOW"] = "LOW";
})(Priority = Priority || (Priority = {}));
export var DeliverableTypeIcon;
(function (DeliverableTypeIcon) {
    DeliverableTypeIcon["BUG"] = "BUG";
    DeliverableTypeIcon["CHILD"] = "CHILD";
    DeliverableTypeIcon["DOCUMENT"] = "DOCUMENT";
    DeliverableTypeIcon["EQUIPMENT"] = "EQUIPMENT";
    DeliverableTypeIcon["OTHER"] = "OTHER";
})(DeliverableTypeIcon = DeliverableTypeIcon || (DeliverableTypeIcon = {}));
export var DeliverableUnit;
(function (DeliverableUnit) {
    DeliverableUnit["NONE"] = "NONE";
    DeliverableUnit["LITER"] = "LITER";
    DeliverableUnit["MILLILITER"] = "MILLILITER";
    DeliverableUnit["GRAM"] = "GRAM";
    DeliverableUnit["ITEM"] = "ITEM";
    DeliverableUnit["BOX"] = "BOX";
})(DeliverableUnit = DeliverableUnit || (DeliverableUnit = {}));
export var TimeRelation;
(function (TimeRelation) {
    TimeRelation["BEFORE"] = "BEFORE";
    TimeRelation["AFTER"] = "AFTER";
    TimeRelation["AT"] = "AT";
    TimeRelation["ANYTIME"] = "ANYTIME";
    TimeRelation["BETWEEN"] = "BETWEEN";
})(TimeRelation = TimeRelation || (TimeRelation = {}));
export var TaskStatus;
(function (TaskStatus) {
    TaskStatus["NEW"] = "NEW";
    TaskStatus["ACTIVE"] = "ACTIVE";
    TaskStatus["PICKED_UP"] = "PICKED_UP";
    TaskStatus["DROPPED_OFF"] = "DROPPED_OFF";
    TaskStatus["CANCELLED"] = "CANCELLED";
    TaskStatus["REJECTED"] = "REJECTED";
    TaskStatus["ABANDONED"] = "ABANDONED";
    TaskStatus["COMPLETED"] = "COMPLETED";
    TaskStatus["PENDING"] = "PENDING";
    TaskStatus["FUTURE"] = "FUTURE";
})(TaskStatus = TaskStatus || (TaskStatus = {}));
export var ModelSortDirection;
(function (ModelSortDirection) {
    ModelSortDirection["ASC"] = "ASC";
    ModelSortDirection["DESC"] = "DESC";
})(ModelSortDirection = ModelSortDirection || (ModelSortDirection = {}));
